import { 
	GET_USER_SOCIAL_REASONS, GET_DELIVERY_ADDRESSES, GET_SOCIAL_REASON_DETAIL, GET_BRANCH_DETAIL, UPDATE_SOCIAL_REASON, 
	CREATE_SOCIAL_REASON, DELETE_SOCIAL_REASON, CREATE_BRANCH, UPDATE_BRANCH, GET_ERRORS, DEACTIVATE_BRANCH, ACTIVATE_BRANCH
} from "../actions/types";

const initialState = {
    socialReasonSelected: '',
    addressSelected:      '',
	actionType:           '',
	error:                '',
    socialReasons:        [],
    addresses:            [],
	branchDetailData:     {},
};

export default function (state = initialState, action) {
    switch (action.type) {
		case GET_USER_SOCIAL_REASONS:
			return {
				...state,
				actionType:    action.type,
				socialReasons: action.payload,
				success:       'Se obtuvieron '  + action.payload.length + ' razones sociales',
			};
		case GET_SOCIAL_REASON_DETAIL:
			return {
				...state,
				actionType:             action.type,
				socialReasonDetailData: action.payload,
			};
		case UPDATE_SOCIAL_REASON:
			return {
				...state,
				actionType: action.type,
				success:    'La razón social fue actualizada exitosamente.'
			};
		case CREATE_SOCIAL_REASON:
			return {
				...state,
				actionType: action.type,
				success:    'La razón social fue creada exitosamente.'
			};
		case DELETE_SOCIAL_REASON:
			return {
				...state,
				actionType: action.type,
				error:      action.payload
			};
		case GET_DELIVERY_ADDRESSES:
			return {
				...state,
				actionType:        action.type,
				deliveryAddresses: action.payload,
				success:           'Se obtuvieron '  + action.payload.length + ' direcciones de entrega'
			};
		case GET_BRANCH_DETAIL:
			return {
				...state,
				actionType:       action.type,
				branchDetailData: action.payload,
			};
		case CREATE_BRANCH:
			return {
				...state,
				actionType: action.type,
				success:    'La dirección fue creada exitosamente.'
			};
		case UPDATE_BRANCH:
			return {
				...state,
				actionType: action.type,
				success:    'La dirección fue actualizada exitosamente.'
			};
		case DEACTIVATE_BRANCH:
			return {
				...state,
				actionType: action.type
			};
		case ACTIVATE_BRANCH:
			return {
				...state,
				actionType: action.type
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error:      action.payload
			};
		default:
			return state;
	}
}